import { Fragment } from "react";

import { ActivityFillCell } from "#/components/ui/activity-fill-cell";
import type { ProfileActivityFill } from "#/lib/calendarHeatmap";
import { cn } from "#/lib/utils";

const LEGEND_ITEMS: Array<{ fill: ProfileActivityFill; label: string }> = [
  { fill: "standard", label: "Standard" },
  { fill: "premium", label: "Premium" },
  { fill: "both", label: "Both" },
];

export function ActivityFillLegend({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-x-1.5 gap-y-1 text-xs text-muted-foreground",
        className,
      )}
    >
      {LEGEND_ITEMS.map((item, index) => (
        <Fragment key={item.fill}>
          {index > 0 ? <span aria-hidden>-</span> : null}
          <span className="inline-flex items-center gap-1">
            <ActivityFillCell fill={item.fill} size="sm" />
            {item.label}
          </span>
        </Fragment>
      ))}
    </div>
  );
}
